import {http} from '../../plugins/http';

export default {

    index(params) {
        return http.get(`/api/v1/admin/global-notifications`, {
            params: params
        });
    },

    showActive() {
        return http.get(`/api/v1/admin/global-notifications/active`);
    },

    edit(notification) {
        return http.get(`/api/v1/admin/global-notifications/${notification}/edit`);
    },

    store(notification) {
        return http.post(`/api/v1/admin/global-notifications`, notification);
    },

    update(notification, params) {
        return http.patch(`/api/v1/admin/global-notifications/${notification}`, params);
    },

    destroy(notification) {
        return http.delete(`/api/v1/admin/global-notifications/${notification}`);
    }

};



// WEBPACK FOOTER //
// ./src/services/Admin/GlobalNotificationsController.js